<sb-card [loading]="!heatmapStatusData.loadingDone">
  <div card-header>
    <h1>{{ 'lang.globals.playerStatus' | translate }}</h1>
    <small>{{ 'lang.globals.betweenCountDays' | translate: { count: timespan() } }}</small>
  </div>
  @if (!inputData()) {
    <div card-header-more class="tw-flex tw-gap-2">
      <sb-comp-dropdown-select
        *ngPermissions="permissionService.Permission.cull_list"
        [inputData]="culls" [dropDownDatatype]="'PLAYER_CULLS'"
        (selectedDataEmitter)="update($event, 'PLAYER_CULLS')" [showColumnIcon]="false"
        [msOptions]="msCullOptions" (msOptionsChange)="msRequest('PLAYER_CULLS', $event)"
        [selectedInputData]="filteredCulls?.length> 0  ? filteredCulls: []">
      </sb-comp-dropdown-select>
      <div class="">
        <input id="device-box" type="text" class="form-control" placeholder="{{'lang.globals.device' | translate}}"
               [(ngModel)]="deviceIds" />
      </div>
      @let fromDate = from();
      @let tillDate = till();
      <div>
        <div class="tw-flex tw-gap-2">
          <sb-local-date-time-input [seconds]="true" [weekNumbers]="true" [initialDate]="fromDate"
                                    [ngClass]="{'alertbox': fromDate && tillDate && fromDate?.value > tillDate?.value}"
                                    (modelChange)="handleDateChangeFrom($event)"></sb-local-date-time-input>

          <sb-local-date-time-input [seconds]="true" [weekNumbers]="true" [initialDate]="tillDate"
                                    (modelChange)="handleDateChangeTill($event)"></sb-local-date-time-input>
        </div>

        <div *ngIf="fromDate && tillDate && fromDate?.value > tillDate?.value"
             class="alert alert-danger">{{ 'lang.globals.dateWarning'|translate }}
        </div>
      </div>
      <button (click)="refreshFromServer()" class="cursor-pointer btn btn-primary">
        &nbsp;&nbsp;{{ 'lang.globals.search' | translate }} &nbsp;
      </button>
    </div>
  }
  <div card-body>

    <div *ngIf="permissionService.hasPermission(permissionService.Permission.ss_nm_reporting) ">
      <sb-heatmap-status-chart #heatmapChart [chartData]="heatmapStatusData"></sb-heatmap-status-chart>
    </div>
  </div>
</sb-card>
